export function lerp(start: number, end: number, time: number): number {
    return start + (end - start) * time;
}

export function clamp(from: number, to: number, value: number): number {
    return Math.max(Math.min(to, value), from);
}